import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	RespondBeneficiaryAddressSuggestionV4,
	RespondBeneficiaryAddressSuggestionV4Request,
} from 'domain/usecases';

export class RemoteRespondBeneficiaryAddressSuggestionV4 implements RespondBeneficiaryAddressSuggestionV4 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<unknown>,
	) {}

	async post(params: RespondBeneficiaryAddressSuggestionV4Request): Promise<void> {
		const {signal, ...body} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
